import { render, staticRenderFns } from "./OrderStatusDispatched.vue?vue&type=template&id=64a4e636&"
import script from "./OrderStatusDispatched.vue?vue&type=script&lang=js&"
export * from "./OrderStatusDispatched.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports